
























































































































































































































import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import { boolean } from 'yup/lib/locale';
import { NumericDictionary } from 'lodash';
import { string } from 'yup';
import { fetchOrdenesCompra } from './fetchOrdenesCompra';

@Component({
  components: {
    FormFieldsContainer,
  },
})
export default class FormularioCostos extends Vue {
  @Prop({ required: true }) precioCarga: string;
  @Prop({ required: true }) compranumero: any;
  @Prop({ required: true }) cantidadCargados: any;
  @Prop({ required: true }) precioCargaOtros: string;
  show = false;
  @Watch('precioCargaOtros')
  calculateFactor() {
    this.formFields.precioCompra.value = this.formatNumber(
      this.precioCarga.toString().replace('.', ','),
      true
    );
    this.formFields.precioTotal.value = this.formatNumber(
      this.precioCargaOtros.toString().replace('.', ','),
      true
    );
  }

  @Watch('cantidadCargados')
  calcularUnitario() {
    let internacion = this.formFields.totalOtros.value.replace(/[.]/g, '');
    let tipoCambio = this.formFields.precioDolar.value.replace(/[.]/g, '');
    tipoCambio = parseFloat(tipoCambio.replace(',', '.'));
    internacion = parseFloat(internacion.replace(',', '.'));
    let flete = this.formFields.flete.value.replace(/[.]/g, '');
    flete = parseFloat(flete.replace(',', '.'));
    let nuevoUnitario: number | string = '';
    if (this.cantidadCargados > 0 && !isNaN(internacion)) {
      nuevoUnitario = parseFloat(internacion) / this.cantidadCargados;
      nuevoUnitario = parseFloat(nuevoUnitario.toString()).toFixed(2);
      this.formFields.costoUnitarioInternacion.value = this.formatNumber(
        nuevoUnitario.toString().replace('.', ','),
        true
      );
      if (isNaN(tipoCambio) || tipoCambio == '') {
        tipoCambio = 0;
        this.formFields.precioDolar.value = this.formatNumber('0', true);
      }
      this.$emit('nuevoUnitario', { nuevoUnitario, tipoCambio, flete });
    } else {
      this.formFields.costoUnitarioInternacion.value =
        'Por favor agregue los costos y equipos';
    }
  }

  formatNumber(data: string, isCalculated: boolean = false) {
    let value = data.toString().replace(/[.]/g, '');
    if (value == null || value == '') {
      value = '0';
    }
    let formated = parseFloat(value.toString().replace(',', '.'))
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (isNaN(parseFloat(formated))) {
      return 0;
    }
    if (!isCalculated) this.calculateInfo();

    return formated;
  }

  calculateInfo() {
    const {
      agencia,
      almacenaje,
      derechos,
      desconsolidacion,
      flete,
      fleteLocal,
      seguro,
      totalOtros,
    } = this.formFields;

    const verifyData = (value: any) => {
      if (!value || value == '') {
        return '0';
      } else {
        let newValue = value.replace(/[.]/g, '');
        return newValue.replace(',', '.');
      }
    };

    const agencia_aduana = verifyData(agencia.value);
    const almacenaje_val = verifyData(almacenaje.value);

    const derechos_val = verifyData(derechos.value);

    const desconsolidacion_val = verifyData(desconsolidacion.value);

    const flete_val = verifyData(flete.value);

    const flete_local_val = verifyData(fleteLocal.value);

    const seguro_val = verifyData(seguro.value);

    const valor_total_otros = (
      parseFloat(agencia_aduana) +
      parseFloat(almacenaje_val) +
      parseFloat(derechos_val) +
      parseFloat(desconsolidacion_val) +
      parseFloat(flete_local_val) +
      parseFloat(seguro_val)
    ).toFixed(2);
    this.$emit('valor_total_otros', valor_total_otros);
    totalOtros.value = this.formatNumber(
      valor_total_otros.toString().replace('.', ','),
      true
    );

    const costoConver = parseFloat(valor_total_otros);
    this.calcularUnitario();
    this.$emit('costoInternacion', costoConver);
  }

  replaceValues(value: string) {
    if (!value || value == '') {
      return 0;
    }
    let newValue = value.replace(/[.]/g, '');
    return parseFloat(newValue.replace(',', '.')).toFixed(2);
  }

  ordesList: any;
  dataCosts: Array<Object> = [];
  ModalConfirmar_TEXTO: string = '';
  ModalConfirmar: boolean = false;

  rules = {
    required: (value: any) => !!value || 'Required.',
    numeric: (value: any) => {
      if (value != '' && value != '0') {
        return /^[0-9,.]+$/.test(value) || 'Solo se permiten números';
      } else {
        return true;
      }
    },
  };

  formFields: {
    precioDolar: any;
    clausula: any;
    tipo_flete: any;
    observacion: any;
    tCAduana: any;
    flete: any;
    fleteLocal: any;
    desconsolidacion: any;
    derechos: any;
    almacenaje: any;
    agencia: any;
    seguro: any;
    totalOtros: any;
    costoUnitarioInternacion: any;
    cantidadCargados: any;
    precioCompra: any;
    precioTotal: any;
  } = {
    precioDolar: {
      label: 'Precio Tipo Cambio',
      value: '',
    },
    clausula: {
      label: 'Clausula Compra',
      value: '',
    },
    tipo_flete: {
      label: 'Tipo Flete',
      value: '',
    },
    observacion: {
      label: 'Observación',
      value: '',
    },
    tCAduana: {
      label: 'T/C Aduana',
      value: '',
    },
    flete: {
      label: 'Flete',
      value: '',
    },
    fleteLocal: {
      label: 'Flete Local',
      value: '',
    },
    desconsolidacion: {
      label: 'Desconsolidación',
      value: '',
    },
    derechos: {
      label: 'Derechos',
      value: '',
    },
    almacenaje: {
      label: 'Almacenaje',
      value: '',
    },
    agencia: {
      label: 'Agencia Aduana',
      value: '',
    },
    seguro: {
      label: 'Seguro',
      value: '',
    },
    totalOtros: {
      label: 'Total Flete y Otros',
      value: '',
    },
    costoUnitarioInternacion: {
      label: 'Costo Unitario Importación',
      value: '',
    },
    cantidadCargados: {
      label: 'Cantidad Equipos Cargados',
      value: '',
    },
    precioCompra: {
      label: 'Costo De Compra Original',
      value: '',
    },
    precioTotal: {
      label: 'Costo Total Compra Con Importación',
      value: '',
    },
  };

  mounted() {}

  onSelectionChanged(params: any) {}

  //abstract;

  //propiedades globales
  loadingService = new LoadingService();
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  async postCostos(): Promise<boolean> {
    const {
      agencia,
      almacenaje,
      derechos,
      desconsolidacion,
      flete,
      fleteLocal,
      seguro,
      totalOtros,
      precioDolar,
      clausula,
      tipo_flete,
      observacion,
      tCAduana,
      costoUnitarioInternacion,
      precioCompra,
      precioTotal,
    } = this.formFields;

    return fetchOrdenesCompra(
      {
        compra: this.compranumero,
        agencia: this.replaceValues(agencia.value),
        almacenaje: this.replaceValues(almacenaje.value),
        derechos: this.replaceValues(derechos.value),
        desconsolidacion: this.replaceValues(desconsolidacion.value),
        flete: this.replaceValues(flete.value),
        flete_local: this.replaceValues(fleteLocal.value),
        seguro: this.replaceValues(seguro.value),
        total_otros: this.replaceValues(totalOtros.value),
        tipo_cambio: this.replaceValues(precioDolar.value),
        clausula: clausula.value,
        tipo_flete: tipo_flete.value,
        observacion: observacion.value,
        tc_aduana: this.replaceValues(tCAduana.value),
        cantidad_equipos: this.cantidadCargados,
        costo_unitario: this.replaceValues(costoUnitarioInternacion.value),
        precio_compra: this.replaceValues(precioCompra.value),
        precio_total: this.replaceValues(precioTotal.value),
      },
      'conectaOrdenesCompra/post_costos_importacion'
    )
      .then((data: any) => {
        return true;
      })
      .catch((error: any) => {
        return false;
      });
  }

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  setBotonNav() {}

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal() {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
  }

  confirmCallback(val: any) {}
}
